module.exports = __webpack_public_path__ + "img/safeplace.b2395598.png";